export const dataHooks = { tooltipText: 'tooltip-text' };
export const TIMEOUT = { enter: 100, exit: 150 };
export const SIZES = { small: 'small', medium: 'medium' };
//# sourceMappingURL=constants.js.map